// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__aE4rY","checked":"Checkbox_checked__lNf3k"};